<template>
  <!-- <v-form ref="geolocation" @submit.prevent="addAddress">
      <v-card outlined class="my-6">
        <v-card-title>Add address</v-card-title>
        <v-card-text class="px-5">
          <gmap-autocomplete
            class="google-autocomplete mt-2"
            large
            placeholder="Search"
            :select-first-on-enter="true"
            :value="addressInput"
          ></gmap-autocomplete>
          <v-text-field
            label="Bussiness Name"
            :rules="rules"
            required
          ></v-text-field>
          <v-text-field

            label="Address Line 1"
            :rules="rules"
            required
          ></v-text-field>
          <v-text-field

            label="Address Line 2"
          ></v-text-field>
          <v-row>
            <v-col>
              <v-text-field

                label="City"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field

                label="Province"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                @change="clearGoogleDetails"
                label="Country"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                @change="clearGoogleDetails"
                label="Postal Code"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="text-right">
        <v-btn text class="mr-2" @click="closeCreateLocationDialog">Dismiss</v-btn>
        <v-btn color="primary" type="submit" :loading="disableButton">Complete</v-btn>
      </div>
  </v-form>-->
  <v-container fluid>
    <v-card flat color="background">
      <v-card-title primary-title>Address</v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="py-0 pt-1" cols="12" md="12">
            <v-text-field
              name="Business Name"
              disabled
              :value="vg_activeBusiness.name"
              label="Business Name"
            ></v-text-field>
          </v-col>
          <v-col class="py-0 pt-1" cols="12" md="6">
            <gmap-autocomplete @place_changed="locationSelected" class="introInput">
              <template v-slot:input="slotProps">
                <v-text-field
                  v-model="locationAddress.address_line_1"
                  label="Address Line 1"
                  ref="input"
                  v-on:listeners="slotProps.listeners"
                  v-on:attrs="slotProps.attrs"
                ></v-text-field>
              </template>
            </gmap-autocomplete>
          </v-col>
          <v-col class="py-0 pt-1" cols="12" md="6">
            <v-text-field
              v-model="locationAddress.address_line_2"
              name="Address Line 2"
              label="Address Line 2 (Optional)"
            ></v-text-field>
          </v-col>
          <v-col class="py-0 pt-1" cols="12" md="6">
            <v-text-field v-model="locationAddress.city" name="City" label="City"></v-text-field>
          </v-col>
          <v-col class="py-0 pt-1" cols="12" md="6">
            <v-text-field v-model="locationAddress.province" name="Province" label="Province"></v-text-field>
          </v-col>
          <v-col class="py-0 pt-1" cols="12" md="6">
            <v-text-field v-model="locationAddress.country" name="Country" label="Country"></v-text-field>
          </v-col>
          <v-col class="py-0 pt-1" cols="12" md="6">
            <v-text-field
              v-model="locationAddress.postal_code"
              name="Postal Code"
              label="Postal Code"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleSave" color="primary">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  created() {
    this.getLocationAddress()
  },
  data() {
    return {
      locationAddress: {
        address_line_1: '',
        address_line_2: '',
        city: '',
        province: '',
        postal_code: '',
        country: '',
        google_place_id: '',
        latitude: '',
        longitude: '',
        formatted_address: ''
      },
      googleAddress: '',
      // determined to decide whether to use post/patch request
      newLocation: false
    }
  },
  computed: {
    ...mapGetters({
      vg_activeBusiness: 'auth/activeBusiness'
    })
  },
  beforeDestroy() {
    if (window.google) {
      delete window.google
    }
  },
  methods: {
    async getLocationAddress() {
      let response
      try {
        response = await LocationAPI.getLocationAddress(this.$route.params.id)
      } catch (error) {
        if (error.response.status === 404) {
          this.newLocation = true
        }
        return console.log(error)
      }
      Object.keys(this.locationAddress).forEach(key => { this.locationAddress[key] = response.data.payload[key] })
      this.newLocation = false
    },
    locationSelected(addressData) {
      console.log(addressData)
      this.googleAddress = addressData
      if (addressData && addressData.address_components) {
        addressData.address_components.forEach((item) => {
          if (item.types.includes('street_number')) {
            this.locationAddress.address_line_1 = item.short_name
          }
          if (item.types.includes('route')) {
            this.locationAddress.address_line_1 =
              this.locationAddress.address_line_1 + ' ' + item.short_name
          }
          if (item.types.includes('sublocality')) {
            this.locationAddress.city = item.short_name
          }
          if (item.types.includes('locality')) {
            this.locationAddress.city = item.short_name
          }
          if (
            item.types.includes('administrative_area_level_1' || 'political')
          ) {
            this.locationAddress.province = item.short_name
          }
          if (item.types.includes('country')) {
            this.locationAddress.country = item.long_name
          }
          // if (item.types.includes('country')) this.locationAddress.country_code = item.short_name
          if (item.types.includes('postal_code')) {
            this.locationAddress.postal_code = item.short_name
          }
        })
        this.locationAddress.business_name = addressData.name
        this.locationAddress.latitude = Number(
          addressData.geometry.location.lat().toFixed(6)
        )
        this.locationAddress.longitude = Number(
          addressData.geometry.location.lng().toFixed(6)
        )
        this.locationAddress.formatted_address = addressData.formatted_address
        if (addressData.place_id) { this.locationAddress.google_place_id = addressData.place_id } else { this.locationAddress.google_place_id = null }
      }
    },
    handleSave() {
      // address_line_2 should be a string
      if (this.locationAddress.address_line_2 === null) {
        this.locationAddress.address_line_2 = ''
      }
      if (this.newLocation) {
        this.createAddress()
      } else {
        this.updateAddress()
      }
    },
    async createAddress() {
      try {
        await LocationAPI.addAddressToLocation({ locationId: this.$route.params.id, data: this.locationAddress })
      } catch (error) {
        return console.log(error)
      }
      this.swal({ title: 'Success', text: 'Address added successfully', timer: 3000 })
      this.newLocation = false
    },
    async updateAddress() {
      try {
        await LocationAPI.updateLocationAddress({ locationId: this.$route.params.id, data: this.locationAddress })
      } catch (error) {
        return console.log(error)
      }
      this.swal({ title: 'Success', text: 'Address updated successfully', timer: 3000 })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
